import { VERTICAL_VISIBLE_INDENT } from '../constants';

export function getRightScrollOffset(container: HTMLUListElement): number | null {
  const childrenList = Array.from(container.children) as HTMLLIElement[];
  const containerOffset = container.offsetLeft;
  const rightBorderPosition = container.offsetWidth + container.scrollLeft;

  const rightHiddenChild = childrenList.find(child => {
    const leftX = child.offsetLeft - containerOffset;
    const rightX = leftX + child.offsetWidth;

    return rightX > rightBorderPosition;
  });

  if (!rightHiddenChild) {
    return null;
  }

  const { offsetLeft, offsetWidth } = rightHiddenChild;

  return offsetLeft + offsetWidth - containerOffset - container.offsetWidth + VERTICAL_VISIBLE_INDENT;
}

export function getLeftScrollOffset(container: HTMLUListElement): number | null {
  const childrenList = Array.from(container.children) as HTMLLIElement[];
  const containerOffset = container.offsetLeft;
  const leftBorderPosition = container.scrollLeft;

  const leftHiddenChildIndex = childrenList.findIndex(child => {
    const leftX = child.offsetLeft - containerOffset;

    return leftX >= leftBorderPosition;
  });
  const leftHiddenChild = leftHiddenChildIndex > 0 ? childrenList[leftHiddenChildIndex - 1] : null;

  if (!leftHiddenChild) {
    return null;
  }

  const { offsetLeft } = leftHiddenChild;

  return offsetLeft - VERTICAL_VISIBLE_INDENT;
}
